import { render, staticRenderFns } from "./DeactivateAccount.vue?vue&type=template&id=28402242&scoped=true"
import script from "./DeactivateAccount.vue?vue&type=script&lang=js"
export * from "./DeactivateAccount.vue?vue&type=script&lang=js"
import style0 from "./DeactivateAccount.vue?vue&type=style&index=0&id=28402242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28402242",
  null
  
)

export default component.exports